// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"159f794c","283":"7bd62daa","284":"e58ae2e6","298":"159f794c","418":"159f794c","527":"117f9980","836":"159f794c","861":"159f794c"}[chunkId] + ".chunk.css";
};